import React from "react";
import "../../assets/styles/sidebar.css";
import { Users, Send, BarChart2, Settings } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path: string) => {
        return location.pathname === path;
    };

    return (
        <aside className="sidebar">
            <div className="" onClick={() => navigate("/")} style={{ cursor: "pointer",textAlign:"center"}}>
                <img src="/images/logo.png" alt="logo" style={{width:"100px"}}/>
                {/* <span>PitchSync</span> */}
            </div>

            <ul className="menu">
                <li className={isActive("/audience") ? "active" : ""} onClick={() => navigate("/audience")}>
                    <Users className="menu-icon" />
                    <span>Audience</span>
                </li>

                <li className={isActive("/campaigns") ? "active" : ""} onClick={() => navigate("/campaigns")}>
                    <Send className="menu-icon" />
                    <span>Campaigns</span>
                </li>

                {/* <li className={isActive("/reports") ? "active" : ""} onClick={() => navigate("/reports")} > */}
                <li className={isActive("/reports") ? "active" : ""} style={{ cursor: "not-allowed", opacity: 0.7 }}>
                    <BarChart2 className="menu-icon" />
                    <span>Reports</span>
                </li>

                <li className={isActive("/settings") ? "active" : ""} onClick={() => navigate("/settings")} >
                    <Settings className="menu-icon" />
                    <span>Settings</span>
                </li>

            </ul>
        </aside>
    );
};

export default Sidebar;